
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';
import headerTpl from './header.html';

/**
 * Directive used for manipulate the HTML DOM elements inside the header component,
 * the which is showed in the all application pages.
 *
 * @returns
 */
function headerComponent() {

	/**
	 * Directive definition.
	 */
	const directive = {
		restrict: 'E',
		templateUrl: headerTpl,
		controller: HeaderController,
		controllerAs: 'headervm',
		bindToController: true
	};

	return directive;

	/**
	 * Controller used by directive for modified the values of the HTML DOM elements in your scope.
	 *
	 * @param {any} $rootScope
	 * @param {any} $mdSidenav
	 * @param {any} $auth
	 * @param {any} $state
	 * @param {any} userAccessConstant
	 * @param {any} navigationConstant
	 * @param {any} utilitiesConstant
	 * @param {any} sessionFactory
	 * @param {any} utilitiesFactory
	 * @param {any} headerFactory
	 */
	function HeaderController($rootScope, $mdSidenav, $auth, $state, userAccessConstant, navigationConstant, utilitiesConstant, sessionFactory, utilitiesFactory, headerFactory, FileSaver) {
		'ngInject';

		/**
		 * Scope for manipulated data in HTML DOM elements.
		 */
		let vm = this;
		vm.toggleLeft = buildToggler('left');
		vm.title = utilitiesConstant.TITLE;

		/**
		 * Walk the sub-menu and store your variables to be able to access them according to the user permits
		 */
		vm.changeActive = (menuCode, menuName, menuIcon) => {
			vm.submenuActive = [];
			vm.menuActive = null;
			vm.iconActive = null;

			const element = _.findLast($rootScope.submenus, elementMenu => elementMenu.menuCode === menuCode);

			if (element){
				vm.submenuActive = element.submenus;
				vm.menuActive = menuName;
				vm.iconActive = menuIcon;
				/**
				 * Checks if the item has sub-menu, and gives the order for access to these
				 */
				if (vm.submenuActive.length > 0) {
					vm.toggleLeft();
				}
			}
		};

		vm.downloadUserManual = () => {
			utilitiesFactory.downloadUserManual().then(
				response => {
					FileSaver.saveAs(response.file, utilitiesConstant.USER_MANUAL_FILE_NAME);
				},
				() => {
					utilitiesFactory.showErrorMessage(utilitiesConstant.MSG_ERROR);
				});
		}

		/**
		 * * function for button, where the user close logout.
		 */
		vm.logout = () => {
			if ($rootScope.userAuth) {
				/**
				 * Call async rest service for destroy token in the Gana Api.
				 */
				utilitiesFactory.logout((utilitiesConstant.URL_ENDPOINT).concat(utilitiesConstant.URL_API_METHOD.LOGOUT)).then(logout, logout);
			}
		};

		function logout() {
			sessionFactory.remove(utilitiesConstant.STORAGE.AUTHENTICATED);
			sessionFactory.remove(utilitiesConstant.STORAGE.USER);

			$auth.logout();

			$rootScope.userAuth = null;
			$rootScope.menuItems = null;
			$rootScope.submenus = null;

			$state.go('authentication');
		}

		/**
		 *  Open nav-menu
		 *
		 * @param {any} componentId
		 * @returns
		 */
		function buildToggler(componentId) {
			return () => {
				$mdSidenav(componentId).toggle();
			};
		}

		/**
		 * Validate if the user is authenticated to create de dynamic menu.
		 */
		(function () {
			const isAuth = sessionFactory.get(utilitiesConstant.STORAGE.AUTHENTICATED) && $auth.isAuthenticated();

			if (isAuth) {
				if (!$rootScope.userAuth) {
					$rootScope.userAuth = angular.fromJson(sessionFactory.get(utilitiesConstant.STORAGE.USER));
				}
				headerFactory.createMenuByProfile($rootScope.userAuth.profile.codeEnum);
			}
		})();
	}
}

export default headerComponent;



// WEBPACK FOOTER //
// ./src/app/core/components/header/header.directive.js